import axios from "../helper/AxiosHelper";
import ApiHelper from "./ApiHelper";



const getTopSkillParticipantCount = async () => {

  // const data = {};
  const response = await axios.get("/passport/getTopSkillParticipantCount");

  return ApiHelper.processResponse(response);
};

// getTopMemberPlayTimeWithOrgSkill?org_id=145&skill_code=hoshun_karate
const getTopMemberPlayTimeWithOrgSkill = async (orgID, skillCode) => {

  const url = `/passport/getTopMemberPlayTimeWithOrgSkill?org_id=${orgID}&skill_code=${skillCode}`;
  const response = await axios.get(url);

  return ApiHelper.processResponse(response);
}



// getTopMemberPlayTimeWithOrgSkill?org_id=145&skill_code=hoshun_karate
const getTopMemberPlayTime = async () => {

  const orgID = 0;
  const skillCode = '';
  
  const url = `/passport/getTopMemberPlayTimeWithOrgSkill?org_id=${orgID}&skill_code=${skillCode}`;
  const response = await axios.get(url);

  return ApiHelper.processResponse(response);
}



const getTopOrgPlayTime = async () => {
  const response = await axios.get("/passport/getTopOrgPlayTime");

  return ApiHelper.processResponse(response);
}



export const LeaderboardApi = {
  getTopMemberPlayTime,
  getTopMemberPlayTimeWithOrgSkill,
  getTopOrgPlayTime,
  getTopSkillParticipantCount,
};
